export { default } from './MrNewsletterSubscription';